// 📒 Carnet de suivi (tour 58)

// Fin d'un cours (« class-completed ») : le prof voit d'abord la fenêtre de la note, l'avis vient après.
// Seulement dans le nouveau design, interrupteur « carnet_suivi » allumé (enabled), pour le prof du cours
export const carnetFirst = ({ userType, enabled, data }) => Number(userType) === 1 && enabled === true && !!data?.class_id;

// « Mes cours » du prof : rappel sur un cours sans note encore modifiable (« Plus tard » ou fenêtre jamais
// remplie), bouton pour écrire ou corriger la note. states : [{ class_id, state, editable_until }]
export const noteStateOf = (states, classId) => (states || []).find((s) => String(s.class_id) === String(classId)) || null;
